import React from 'react';
import { Table } from 'react-bootstrap';
import Row from "./components/Row";

const DynamicHourlyFactorTable = ({ report, onSortChange }) => {
    const rows = report.map((row, index) => (<Row {...row} key={index} />));

    return (
        <Table bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <thead>
                <tr>
                    <th onClick={() => onSortChange('hour')}>Hour</th>
                    <th onClick={() => onSortChange('affid')}>Affid</th>
                    <th onClick={() => onSortChange('subid')}>Subid</th>
                    <th onClick={() => onSortChange('country')}>Country</th>
                    <th onClick={() => onSortChange('revenue')}>Revenue</th>
                    <th onClick={() => onSortChange('spend')}>Spend</th>
                    <th onClick={() => onSortChange('roi')}>Roi</th>
                    <th onClick={() => onSortChange('factor')}>Factor</th>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    )
};

export default DynamicHourlyFactorTable;


// WEBPACK FOOTER //
// ./src/scenes/DynamicHourlyCutoff/components/Table/index.js